import React from 'react';
import { PitchBreakPlotChart as NYYPitchBreakPlotChart } from 'yankees-react-utils';
import { usePitchVideoFn } from '../data';
import { VideoPlayerModal } from './VideoPlayer';

const PitchBreakPlotChart = (props) => {
    const pitchVideoFn = usePitchVideoFn();
    if (window.$MatchupEmbeddedVideoDisabled) {
        return (
            <NYYPitchBreakPlotChart {...props} />
        );
    }
    return (
        <NYYPitchBreakPlotChart pitchVideoFn={pitchVideoFn} videoPlayerModal={VideoPlayerModal} {...props} />
    );
};

export default PitchBreakPlotChart;
